<template>
    <el-input v-model="money" type="text" placeholder="106.58" :disabled="disabled" @change="change">
        <i slot="prefix" class="fas fa-fw fa-dollar-sign mt-3"></i>
    </el-input>
</template>

<script>
    import Dinero from 'dinero.js';

    export default {
        name: 'MoneyInput',
        props: {
            value: {
                type: Object,
                default: () => ({
                    amount: 0,
                    currency: 'USD',
                }),
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                money: 0,
            };
        },
        watch: {
            value() {
                this.setVar();
            },
        },
        created() {
            this.setVar();
        },
        methods: {
            setVar() {
                const value = new Dinero(this.value);
                this.money = value.toFormat('0.00');
            },
            change() {
                this.$emit('input', {
                    amount: Math.round(Number.parseFloat(this.money.replace(/,/, '')) * 100),
                    currency: 'USD',
                });
            },
        },
    };
</script>
